import { render } from "./RequestApprovalHistory.vue?vue&type=template&id=6273b5dc"
import script from "./RequestApprovalHistory.vue?vue&type=script&lang=js"
export * from "./RequestApprovalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__